import { render, staticRenderFns } from "./CreateCaseModal.vue?vue&type=template&id=facbbb24&scoped=true&"
import script from "./CreateCaseModal.vue?vue&type=script&lang=js&"
export * from "./CreateCaseModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCaseModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateCaseModal.vue?vue&type=style&index=1&id=facbbb24&lang=scss&scoped=true&"
import style2 from "./CreateCaseModal.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facbbb24",
  null
  
)

export default component.exports